// import AppNavigation from "./app-navigation/AppNavigation";
import AppNavigation from "./app-navigation/AppNavigation";
import AOS from 'aos';
import 'aos/dist/aos.css';


AOS.init();
function App() {
  return <AppNavigation />;
}

export default App;
